import * as actionTypes from "../constants";

// Common actions
export const requestStart = () => {
  return {
    type: actionTypes.ADMIN_REQUEST_START
  };
};

export const requestSuccess = (message = null) => {
  return {
    type: actionTypes.ADMIN_REQUEST_SUCCESS,
    successMessage: message
  };
};

export const requestFail = (error) => {
  // Extract only serializable data from error
  const serializedError = {
    data: error?.response?.data || {},
    status: error?.response?.status || null,
    statusText: error?.response?.statusText || 'Error occurred'
  };
  
  return {
    type: actionTypes.ADMIN_REQUEST_FAIL,
    error: serializedError
  };
};

export const clearError = () => {
  return {
    type: actionTypes.ADMIN_CLEAR_ERROR
  };
};

export const clearSuccess = () => {
  return {
    type: actionTypes.ADMIN_CLEAR_SUCCESS
  };
};

// Brands actions
export const brandsFetchSuccess = (brands) => {
  return {
    type: actionTypes.BRANDS_FETCH_SUCCESS,
    brands
  };
};

export const brandCreateSuccess = (brand) => {
  return {
    type: actionTypes.BRAND_CREATE_SUCCESS,
    brand
  };
};

export const brandUpdateSuccess = (brand) => {
  return {
    type: actionTypes.BRAND_UPDATE_SUCCESS,
    brand
  };
};

export const brandDeleteSuccess = (brandId) => {
  return {
    type: actionTypes.BRAND_DELETE_SUCCESS,
    brandId
  };
};

export const brandDetailSuccess = (brand) => {
  return {
    type: actionTypes.BRAND_DETAIL_SUCCESS,
    brand
  };
};

// Sub Brands actions
export const subBrandsLoadingStart = () => {
  return {
    type: actionTypes.SUB_BRANDS_LOADING_START
  };
};

export const subBrandsFetchSuccess = (subBrands) => {
  return {
    type: actionTypes.SUB_BRANDS_FETCH_SUCCESS,
    subBrands
  };
};

export const subBrandCreateSuccess = (subBrand) => {
  return {
    type: actionTypes.SUB_BRAND_CREATE_SUCCESS,
    subBrand
  };
};

export const subBrandUpdateSuccess = (subBrand) => {
  return {
    type: actionTypes.SUB_BRAND_UPDATE_SUCCESS,
    subBrand
  };
};

export const subBrandDeleteSuccess = (subBrandId) => {
  return {
    type: actionTypes.SUB_BRAND_DELETE_SUCCESS,
    subBrandId
  };
};

export const subBrandDetailSuccess = (subBrand) => {
  return {
    type: actionTypes.SUB_BRAND_DETAIL_SUCCESS,
    subBrand
  };
};

// Vendor actions
export const vendorsLoadingStart = () => {
  return {
    type: actionTypes.VENDORS_LOADING_START
  };
};

export const vendorsFetchSuccess = (vendors) => {
  return {
    type: actionTypes.VENDORS_FETCH_SUCCESS,
    vendors
  };
};

export const vendorDetailSuccess = (vendor) => {
  return {
    type: actionTypes.VENDOR_DETAIL_SUCCESS,
    vendor
  };
};

export const vendorCreateSuccess = (vendor) => {
  return {
    type: actionTypes.VENDOR_CREATE_SUCCESS,
    vendor
  };
};

export const vendorUpdateSuccess = (vendor) => {
  return {
    type: actionTypes.VENDOR_UPDATE_SUCCESS,
    vendor
  };
};

export const vendorDeleteSuccess = (vendorId) => {
  return {
    type: actionTypes.VENDOR_DELETE_SUCCESS,
    vendorId
  };
};

// Categories actions
export const categoriesLoadingStart = () => {
  return {
    type: actionTypes.CATEGORIES_LOADING_START
  };
};

export const categoriesFetchSuccess = (categories) => {
  return {
    type: actionTypes.CATEGORIES_FETCH_SUCCESS,
    categories
  };
};

export const categoryCreateSuccess = (category) => {
  return {
    type: actionTypes.CATEGORY_CREATE_SUCCESS,
    category
  };
};

export const categoryUpdateSuccess = (category) => {
  return {
    type: actionTypes.CATEGORY_UPDATE_SUCCESS,
    category
  };
};

export const categoryDeleteSuccess = (categoryId) => {
  return {
    type: actionTypes.CATEGORY_DELETE_SUCCESS,
    categoryId
  };
};

export const categoryDetailSuccess = (category) => {
  return {
    type: actionTypes.CATEGORY_DETAIL_SUCCESS,
    category
  };
};

// Vendor/Wallet actions
export const vendorDetailsFetchSuccess = (vendorDetails) => {
  return {
    type: actionTypes.VENDOR_DETAILS_FETCH_SUCCESS,
    vendorDetails
  };
};

export const vendorDetailsUpdateSuccess = (vendorDetails) => {
  return {
    type: actionTypes.VENDOR_DETAILS_UPDATE_SUCCESS,
    vendorDetails
  };
};

// Orders actions
export const ordersLoadingStart = () => {
  return {
    type: actionTypes.ORDERS_LOADING_START
  };
};

export const ordersFetchSuccess = (orders, mobileNumber) => {
  return {
    type: actionTypes.ORDERS_FETCH_SUCCESS,
    orders,
    mobileNumber
  };
};

export const orderDetailSuccess = (order) => {
  return {
    type: actionTypes.ORDER_DETAIL_SUCCESS,
    order
  };
};

export const ordersClear = () => {
  return {
    type: actionTypes.ORDERS_CLEAR
  };
};

export const orderUpdateSuccess = (order) => {
  return {
    type: actionTypes.ORDER_UPDATE_SUCCESS,
    order
  };
};

// Transactions actions
export const transactionsLoadingStart = () => {
  return {
    type: actionTypes.TRANSACTIONS_LOADING_START
  };
};

export const transactionsFetchSuccess = (transactions) => {
  return {
    type: actionTypes.TRANSACTIONS_FETCH_SUCCESS,
    transactions
  };
};

export const transactionsClear = () => {
  return {
    type: actionTypes.TRANSACTIONS_CLEAR
  };
};